// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(orderEligibilityStatus) {
  switch (orderEligibilityStatus) {
    case /* ReadyForOrders */0 :
        return "Ready to receive Orders";
    case /* Waitlisted */1 :
        return "Waitlisted";
    case /* Suspended */2 :
        return "Suspended";
    case /* Terminated */3 :
        return "Terminated";
    case /* YetToCompleteTraining */4 :
        return "Yet to complete training";
    case /* NotAvailable */5 :
        return "Status not Available";
    
  }
}

export {
  toString ,
  
}
/* No side effect */
